// @flow

import type {
  CommentOperationsById,
} from 'hfty-operator-comments/types'

// Constants
import {
  TREE,
  OPERATIONS_BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

type CommentOperationsSelector = (state: Object) => CommentOperationsById

export default (traverse([TREE, OPERATIONS_BRANCH]): CommentOperationsSelector)
